export default __webpack_public_path__ + "static/media/cway.5e316a6f.jpeg";